// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"05fe42d25b6164222cda","655":"0782a792b258feee8dd6"}[chunkId] + ".js";
};